export default class FadeAnimation {

  startTime = 0;
  endTime = 0;
  direction = 'in';
  object = null;

  constructor({ startTime, endTime, direction }, object) {
    this.startTime = startTime * 1000;
    this.endTime = endTime * 1000;
    this.direction = direction;
    this.object = object;
  }

  _in(time) {
    const duration = this.endTime - this.startTime;
    let opacity = 0;

    if (this.startTime <= time && time <= this.endTime) {
      const currentTime = time - this.startTime;
      opacity += currentTime / duration;

      this.object.set({ opacity });
    }
  }

  _out(time) {
    const duration = this.endTime - this.startTime;
    let opacity = 1;

    if (this.startTime <= time && time <= this.endTime) {
      const currentTime = time - this.startTime;
      opacity -= currentTime / duration;

      this.object.set({ opacity });
    }
  }

  render(time) {
    if (!this.object) return;

    this[`_${this.direction}`](time);
  }
}